// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1Zh9g","card":"styles_card__+hZaq","activeCard":"styles_activeCard__j+Wj6","active":"styles_active__6pcrK","fadeIn":"styles_fadeIn__-g1ii"};